import { MediaExtensionElement } from "../media-extension-element.js";
import { GoogleCastExtension } from "@videojs/google-cast";
//#region src/extensions/google-cast/extension.ts
/**
* Adds the Google Cast extension to the surrounding player's media.
*
* Renders nothing — place it inside the player as a sibling of the media element and it follows the active media.
*
* @example
*   ```html
*   <video-player>
*   <hlsjs-video src="https://example.com/stream.m3u8"></hlsjs-video>
*   <google-cast receiver="YOUR_APP_ID"></google-cast>
*   </video-player>
*   ```;
*/
var GoogleCastExtension$1 = class extends MediaExtensionElement {
	static {
		this.tagName = "google-cast";
	}
	static {
		this.properties = {
			src: { type: String },
			contentType: {
				type: String,
				attribute: "content-type"
			},
			streamType: {
				type: String,
				attribute: "stream-type"
			},
			receiver: { type: String }
		};
	}
	createComponent() {
		return new GoogleCastExtension();
	}
	/** Source URL loaded on the Cast receiver. Falls back to the media's `src` / `currentSrc`. */
	get src() {
		return this.component.src ?? "";
	}
	set src(value) {
		this.component.src = value ?? void 0;
	}
	/** MIME type of the Cast source. When unset, the receiver infers it from the URL. */
	get contentType() {
		return this.component.contentType;
	}
	set contentType(value) {
		this.component.contentType = value ?? void 0;
	}
	/** Stream type used on the Cast receiver. Falls back to the media's `streamType`. */
	get streamType() {
		return this.component.streamType;
	}
	set streamType(value) {
		this.component.streamType = value ?? void 0;
	}
	/** Cast receiver application ID. Defaults to Google's default media receiver. */
	get receiver() {
		return this.component.receiver;
	}
	set receiver(value) {
		this.component.receiver = value ?? void 0;
	}
	/** Custom data sent to the Cast receiver with the load request. */
	get customData() {
		return this.component.customData;
	}
	set customData(value) {
		this.component.customData = value;
	}
};
//#endregion
export { GoogleCastExtension$1 as GoogleCastExtension };

//# sourceMappingURL=extension.js.map